import React from 'react';
import _ from 'lodash';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import Icon from '@sketchpixy/rubix/lib/Icon';

const Option = ({ pressed, value, label, valueKey, isSelected }) => (
  <div onClick={() => pressed(value, valueKey)} style={{ color: (isSelected ? 'white' : 'gray') }}>
    <Icon glyph={(isSelected ? 'icon-simple-line-icons-check' : 'icon-simple-line-icons-ban')} style={{ paddingRight: 5 }} />
    {label}
  </div>
);

const Selector = ({ options, currentValue, valueKey, isSelecting, toggleSelection, toggleSelector, onOptionSelected, cardLeftPosition }) => {
  const currentOption = _.find(options, { value: currentValue && currentValue.value }); 
  const currentLabel = currentOption && currentOption.label;
  let selectionCard, link;
  const buttons = _.map(options, (option, index) => {
    return <Option
      valueKey={valueKey}
      key={index}
      label={option.label}
      value={option.value}
      isSelected={option.value === currentValue && currentValue.value}
      pressed={value => onOptionSelected(value, valueKey)}
    />;
  });
  return (
    <span style={{ position: 'relative' }}>
      <span 
        style={{ color: '#1b97c2', fontWeight: 'bold', cursor: 'pointer', textDecoration: 'underline' }}
        onClick={() => toggleSelection(valueKey, link.getBoundingClientRect(), selectionCard.getBoundingClientRect())}
        ref={c => (link = c)}
      >
        {currentLabel}
      </span>
      <div
        className="card"
        style={{
          padding: 0,
          position: 'absolute',
          backgroundColor: 'white',
          bottom: -15,
          left: -cardLeftPosition,
          zIndex: 10000,
          minWidth: 200,
          minHeight: 100,
          visibility: isSelecting === valueKey ? 'visible' : 'hidden',
        }}
        ref={c => (selectionCard = c)}
      >
        <div style={{ padding: 5, backgroundColor: '#157495', color: 'white' }}>
          {buttons}
        </div>
        <div onClick={() => toggleSelector()} style={{ color: '#1b97c2', fontWeight: 'bold', textAlign: 'center', lineHeight: '220%' }}>
          <Entity entity="close" />
        </div>
      </div>
    </span>
  );
};

class SentenceSelector extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isSelecting: false,
      cardLeftPosition: 200,
    };
    this.selectionCard = null;
    this.link = null;
    this.selectorBox = null;
  }

  onOptionSelected(currentSelection, index, options, selectedValues) {
    const { input } = this.props;
    const newValue = _.find(options[index], option => option.value === currentSelection);
    const newArrayValues = _.isEmpty(selectedValues) ? {} : selectedValues;
    newArrayValues[index] = newValue;
    input.onChange(newArrayValues);
    this.toggleSelection();
  }

  toggleSelection(key, link, card) {
    const { isSelecting } = this.state;
    const cardPosition = card && !_.isNull(key) && (card.right > window.innerWidth ? -(window.innerWidth - (card.right + 50)) : (card.width - link.width) / 2);
    this.setState({ isSelecting: ((isSelecting === key || key === null) ? null : key) }, () => {
      if (!_.isNull(isSelecting)) this.setState({ cardLeftPosition: cardPosition });
    });
  }

  toggleSelector() {
    const { isSelecting } = this.state;
    this.setState({ isSelecting: !isSelecting });
  }

  render() {
    const { sentence, options, containerStyle, textStyle, input: { value: selectedValues }, input } = this.props;
    const { isSelecting, cardLeftPosition } = this.state;
    const trunks = sentence.split(/\$[0-9]/);
    const valuesSelected = selectedValues && !_.isEmpty(selectedValues) ? selectedValues : [];
    return (
      <div style={containerStyle} ref={(g) => { this.selectorBox = g; }}>
        <div style={textStyle}>
          {_.map(trunks, (trunk, index) => {
            let selector = null;
            if (options && options[`${index}`]) {
              const currentValueSelected = !_.isEmpty(valuesSelected) && valuesSelected[index] ? _.find(options[`${index}`], option => option.value === valuesSelected[index].value) : options[`${index}`][0];
              selector = <Selector
                key={index}
                valueKey={index}
                options={options[`${index}`]}
                currentValue={currentValueSelected}
                input={input}
                isSelecting={isSelecting}
                cardLeftPosition={cardLeftPosition}
                toggleSelection={(key, link, card) => this.toggleSelection(key, link, card)}
                onOptionSelected={selection => this.onOptionSelected(selection, index, options, valuesSelected)}
                toggleSelector={() => this.toggleSelector()}
                onHandleChange={selection => input.onChange(selection)}
              />;
            }
            return (
              <span>
                <span>{trunk}</span>
                <span>{selector}</span>
              </span>
            );
          })
        }</div>
      </div>
    );
  }
}

export default SentenceSelector;

